
import { Component, Prop } from "vue-property-decorator";
import {
    HcPageModel,
} from "@dev/hc-components";
import TemplateOptions from "@/module/main/page/TemplateOptionsEnum";
import Culture from "@/module/main/page/CultureEnum";
import IBroker from "@/module/main/model/applicationForm/IBroker";

@Component
export default class Broker extends HcPageModel {
    @Prop({type: Object}) public value!: IBroker;
    @Prop({type: String}) public culture!: Culture;
    @Prop({type: String}) public template!: TemplateOptions;

    protected pageName: string = "broker";
}
